"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilesPanel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _importedBottomSheet = require("@common/components/chat-composer/sheets/imported-bottom-sheet");
var _LocalFilesPanel = require("./LocalFilesPanel");
var _ChatContext = require("../../context/ChatContext");
var _useConversationProject = require("../../hooks/useConversationProject");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FilesPanel = exports.FilesPanel = function FilesPanel(_ref) {
  var onClose = _ref.onClose,
    onAddFiles = _ref.onAddFiles,
    onSelectSavedFile = _ref.onSelectSavedFile,
    parentIsOpen = _ref.isOpen,
    selectedFiles = _ref.selectedFiles,
    onRemoveFiles = _ref.onRemoveFiles,
    onRemoveSavedFile = _ref.onRemoveSavedFile;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var timeoutRef = (0, _react.useRef)(null);
  var _useChat = (0, _ChatContext.useChat)(),
    artifacts = _useChat.artifacts,
    recentArtifactIds = _useChat.recentArtifactIds,
    flashingArtifactIds = _useChat.flashingArtifactIds,
    notifyFilesPanelOpen = _useChat.notifyFilesPanelOpen,
    notifyFilesPanelClose = _useChat.notifyFilesPanelClose,
    markArtifactSeen = _useChat.markArtifactSeen,
    handleDeleteArtifact = _useChat.handleDeleteArtifact,
    handlePromoteArtifact = _useChat.handlePromoteArtifact,
    selectedConversation = _useChat.selectedConversation;
  var _useConversationProje = (0, _useConversationProject.useConversationProject)(selectedConversation === null || selectedConversation === void 0 ? void 0 : selectedConversation.id),
    project = _useConversationProje.project;
  var hasWorkspace = !!project;
  (0, _react.useEffect)(function () {
    if (parentIsOpen) {
      handleOpen();
      // Fire-and-forget: let the chat context clear the plus-button dot and
      // trigger the per-artifact glow animation.
      notifyFilesPanelOpen();
    } else {
      handleClose();
    }
    return function () {
      clearTimeout(timeoutRef.current);
    };
  }, [parentIsOpen]);
  var handleOpen = function handleOpen() {
    return setIsOpen(true);
  };
  var handleClose = function handleClose() {
    setIsOpen(false);
    notifyFilesPanelClose();
    timeoutRef.current = setTimeout(onClose, 250);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_importedBottomSheet.BottomSheet, {
    title: "Local files",
    onClose: handleClose,
    open: isOpen,
    onEscapeKeyDown: function onEscapeKeyDown(event) {
      return event.preventDefault();
    },
    "data-sentry-element": "BottomSheet",
    "data-sentry-component": "FilesPanel",
    "data-sentry-source-file": "FilesPanel.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalFilesPanel.LocalFilesPanel, {
      onClose: handleClose,
      onFilesSelected: onAddFiles,
      onSelectSavedFile: onSelectSavedFile,
      selectedFiles: selectedFiles,
      onRemoveFiles: onRemoveFiles,
      onRemoveSavedFile: onRemoveSavedFile,
      artifacts: artifacts,
      recentArtifactIds: recentArtifactIds,
      flashingArtifactIds: flashingArtifactIds,
      onArtifactClick: markArtifactSeen,
      onDeleteArtifact: handleDeleteArtifact,
      onPromoteArtifact: handlePromoteArtifact,
      hasWorkspace: hasWorkspace,
      "data-sentry-element": "LocalFilesPanel",
      "data-sentry-source-file": "FilesPanel.tsx"
    })
  });
};